import axios from 'axios';

// eslint-disable-next-line
const API = 'http://pricememo.ksb.com.br/api/';
// eslint-disable-next-line
const DEV = 'https://pricedemo.proxy.systems/api/';

const api = axios.create({
    baseURL: DEV
});

export { api };
